@if (shouldRenderCircles()) {
  @for (circleGeometry of legacyCircleGeometry; track $index; let i = $index) {
    <mgl-geojson-source [id]="'circle' + i">
      <mgl-feature [geometry]="circleGeometry"></mgl-feature>
    </mgl-geojson-source>

    <mgl-layer
      [id]="'circle' + i"
      type="line"
      [source]="'circle' + i"
      [paint]="circlePaint()">
    </mgl-layer>

    @if (circleLabels[i]) {
      <mgl-geojson-source [id]="'label-source' + i">
        <mgl-feature
          [geometry]="circleLabels[i].geometry"
          [properties]="{ title: circleLabels[i].text }">
        </mgl-feature>
      </mgl-geojson-source>

      <mgl-layer
        [id]="'label-layer' + i"
        type="symbol"
        [source]="'label-source' + i"
        [layout]="{
          'text-field': ['get', 'title'],
          'text-size': 12,
          'text-offset': [0, -0.6],
          'text-anchor': 'bottom',
        }"
        [paint]="{
          'text-color': circlePaint()?.['line-color'],
          'text-halo-color': getTextHaloColor(),
          'text-halo-width': 1,
        }">
      </mgl-layer>
    }
  }
}
